var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.5C0 1.39543 0.895431 0.5 2 0.5H8.58579C9.11622 0.5 9.62493 0.710714 10 1.08579L12.9142 4L23 4C24.1046 4 25 4.89543 25 6V12.5H23V6H12.9142C12.3838 6 11.8751 5.78929 11.5 5.41421L8.58579 2.5L2 2.5V19.5H14V21.5H2C0.89543 21.5 0 20.6046 0 19.5V2.5ZM20 20.5H17V18.5H20V15.5H22V18.5H25V20.5H22V23.5H20V20.5Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderLarge);
export default __webpack_public_path__ + "static/media/folder-large.70a19ee4e66fea69194f9860f3bdec42.svg";
export { ForwardRef as ReactComponent };